@use '@design/design-tokens/typography/typography' as *;

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  & span,
  & div {
    @include typography-v2-body-base;
  }
}

.leftContainer {
  display: flex;
  align-items: center;
  gap: 8px;

  & img {
    width: 18px;
  }

  & div {
    display: inline-flex;
    align-items: center;
    gap: 8px;

    &:hover {
      text-decoration: underline;
    }
  }

  & svg {
    fill: var(--icon-soft);
    cursor: pointer;
  }
}
